// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"f4d71ca5","316":"6f346c30","683":"edbb8658","697":"2a73a152"}[chunkId] + ".chunk.js";
};